import React from 'react';

/**
 * BrandMark — Dathent logo + wordmark.
 * Source: design/shared/shell.jsx
 */
export default function BrandMark({ size = 28, withText = true, sub }) {
  return (
    <div className="brand">
      <img
        src="/assets/dathent-logo.png"
        alt="Dathent"
        width={size}
        height={size}
        style={{ display: 'block', borderRadius: 6, objectFit: 'contain' }}
      />
      {withText && <span className="brand-name">Dathent</span>}
      {sub && <span className="brand-sub">{sub}</span>}
    </div>
  );
}
